<template>
  <LayoutRegistration>
    <template #main>
      <h2 class="text-3xl my-0">500</h2>
      <h3 class="text-2xl mt-2">{{ $t('regWizPopUp.routes.notAllowed.subheading') }}</h3>
    </template>
  </LayoutRegistration>
</template>

<script>

import { mapMutations } from 'vuex';
import LayoutRegistration from '../layouts/Registration.vue';

export default {
  name: 'ViewNotAllowed',
  metaInfo: {
    title: '500',
  },
  components: {
    LayoutRegistration,
  },
  methods: {
    ...mapMutations([
      'SET_LOADING_STATE',
    ]),
  },
  mounted() {
    this.SET_LOADING_STATE(false);
  },
};
</script>
